// extracted by mini-css-extract-plugin
module.exports = {"max_content":"SectionWork_max_content__3DetD","margin_right":"SectionWork_margin_right__1urtA"};